<template>
  <transition name="msgbox-fade">
    <div class="self-msgbox-wrapper"
         v-show="visible">
      <div class="self-msgbox  ">
        <div class="title-tip">
          <div class="title-tip-left">
            <div class="msg-icon-c clearfix">
              <svg 
                :class="[ 
                  type == 'warning' ?  'warning-col' : type == 'success' ? 'succ-col'  : 'err-col', 
                  'icon'
                ]"
                aria-hidden="true">
                <use :xlink:href="iconName"></use>
              </svg>
            </div>
            <div class="msg">
              {{message}}
            </div>
          </div>
          <i class="close-icon-c"
            v-if="closeBtn && type == 'success'"
            @click="close">
            <svg class="icon"
                aria-hidden="true">
              <use xlink:href="#nwt-icon-guanbi"></use>
            </svg>
          </i>
        </div>
        <div class="content-c  clearfix">
          <div class="extra-msg">
            <!-- {{ messageExtra }} -->
            <div v-if="messageExtra !== null" v-html="msgHTML"></div>
            <slot v-else>
            </slot>
          </div>
        </div>
        <div class="self-msgbox-footer" v-if="btns.length">
          <h-button
            class="primary-ghost-btn"
            v-if="btns[1]"
            @click="close">{{btns[1]}}</h-button>
          <h-button
          class="primary-btn"
          v-if="btns[0]"
          :disabled="countdown !== 0"
          @click="confirm">{{countdown > 0 ? '确认(' + countdown + '秒)' : btns[0]}}</h-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
const ICONMAP = {
  success: '#nwt-icon-chenggong',
  warning: '#nwt-icon-tishi',
  error: '#nwt-icon-shibai'
}
import DOMPurify from 'dompurify';
export default {
  data() {
    return {
      type: 'warning',
      message: '',
      messageExtra: '',
      duration: 0,
      btns: [],
      onClose: null,
      onConfirm: null,
      visible: false,
      closed: false,
      timer: -1,
      closeBtn: true,
      countdown: 0
    }
  },
  computed: {
    iconName() {
      return this.type ? ICONMAP[this.type] : ICONMAP['warning']
    },
    msgHTML() {
      // 使用 DOMPurify 库对 messageHTML 进行 HTML 清理和过滤
      return DOMPurify.sanitize(this.messageExtra);
    }
  },
  methods: {
    destroyElement() {
      this.$el.removeEventListener('animationend', this.destroyElement)
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    },
    close() {
      this.closed = true
      this.onClose(this)
    },
    confirm() {
      this.onConfirm(this)
      this.closed = true
    },
    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          if (!this.closed) {
            this.close()
          }
        }, this.duration)
      }
    },
    keydown(e) {
      // esc关闭
      if (e.keyCode === 27) {
        if (!this.closed) {
          this.close()
        }
      }
    }
  },
  watch: {
    closed(newVal) {
      if (newVal) {
        this.visible = false
        window.selfMsgFlag = 0
        this.$el.addEventListener('animationend', this.destroyElement)
      }
    }
  },
  mounted() {
    this.startTimer()
    document.addEventListener('keydown', this.keydown)
    if (this.countdown > 0) {
      let countdownInterval = setInterval(() => {
        this.countdown = this.countdown - 1
        if (this.countdown === 0) {
          clearInterval(countdownInterval)
        }
      }, 1000)
    }
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keydown)
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme.scss';

.warning-col {
  color: $warning-color;
}

.succ-col {
  color: $succ-color;
}

.err-col {
  color: $err-color;
}

.msgbox-fade-enter-active {
  animation: msgbox-fade-in 0.3s;
}
.msgbox-fade-leave-active {
  animation: msgbox-fade-out 0.3s;
}

@keyframes msgbox-fade-in {
  0% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }

  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes msgbox-fade-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }

  100% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
}

.self-msgbox-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 120%; // 设置120%是为了动画时半透明背景仍然全覆盖页面
  text-align: center;
  z-index: 2018;
  background: rgba(0, 0, 0, 0.5);

  &:after {
    content: '';
    display: inline-block;
    height: 83.3%; // 与屏幕等高，self-msgbox的vertical-align middle就能使其居中: 120% * 83.3% = 100%
    width: 0px;
    vertical-align: middle;
  }

  .self-msgbox {
    position: relative;
    display: inline-block;
    width: 420px;
    padding: 12px 24px 24px 24px;
    vertical-align: middle;
    background-color: #fff;
    border-radius: 3px;
    border: 1px solid #ebeef5;
    font-size: 18px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    text-align: left;
    overflow: hidden;
    backface-visibility: hidden;
    .title-tip {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title-tip-left {
        display: flex;
        align-items: center;
        .msg {
          min-height: 36px;
          padding-top: 10px;
          padding-bottom: 6px;
          font-size: 14px;
          font-weight: 700;
          color: #333;
        }
        .msg-icon-c {
          margin-right: 10px;
          font-size: 24px;
          .icon {
            vertical-align: middle;
          }
        }
      }
    }
    .close-icon-c {
      font-size: 16px;
      cursor: pointer;
      color: #999999;
      &:hover {
        color: $main-color-hover;
      }
    }

    .content-c {
      max-height: 500px;
      margin-top: 14px;
      margin-left: 4px;
      overflow: scroll;
      .extra-msg {
        height: 100%;
        font-size: 14px;
        color: #666;
        white-space: pre-wrap;
      }
    }

    .self-msgbox-footer {
      position: relative;
      top: 7px;
      text-align: center;
      padding-top: 20px;

      .h-btn {
        margin: 0 5px;
      }
    }
  }
}
</style>
